import React from 'react';
import moment from 'moment';    
import { format, parseISO } from "date-fns";

export const getFormattedDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString();
  }


export const formatDateToServer = (dateStr) => {
      return moment(dateStr).format('YYYY MM DD')

}

export const formatGetYear = (dateStr) => {
  return moment(dateStr).format('YYYY')

}

export const formatShortDate = (dateStr) => {
  return moment(dateStr).format('MM/DD/yyyy')

}


export const formatDate = (val, template) => {
  if(!template)
      template = "MM/dd/yyyy"
  if(!val)
      return null;
  
  return format(parseISO(val), template);
  
};

